import showQuestion from 'components/Questionnaires/questions';

export const requiredValidator = value => value && value.trim().length > 0;
requiredValidator.displayName = 'requiredValidator';

export const integerValidator = value => !value || (!Number.isNaN(value) && !Number.isNaN(parseFloat(value)));
integerValidator.displayName = 'integerValidator';

export const rangeValidator = (value, min, max) => !value || Number.isNaN(value) || (((min === null || min === undefined) || min <= Number(value)) && ((max === null && max === undefined) || max >= Number(value)));
rangeValidator.displayName = 'rangeValidator';

export const lengthValidator = (value, length) => !value || value.length === length;
lengthValidator.displayName = 'lengthValidator';

export const sameCharacterValidator = value => !value || !(/^(.)\1{1,}$/.test(value));
sameCharacterValidator.displayName = 'sameCharacterValidator';

export const sequentialIntegerValidator = (value) => {
  if (!value || value.length === 1) {
    return true;
  }

  for (let i = 0; i < value.length - 1; i += 1) {
    if (i < value.length - 1) {
      let currentNumber = parseInt(value[i], 10);
      const nextNumber = parseInt(value[i + 1], 10);
      currentNumber += 1;
      if (currentNumber !== nextNumber) {
        return true;
      }
    }
  }
  return false;
};
sequentialIntegerValidator.displayName = 'sequentialIntegerValidator';

export const validateQuestion = (question) => {
  if (question.answer === undefined) {
    return;
  }

  let newIsValid = true;
  const newErrorMessages = [];
  if (question?.validation?.conditions) {
    question.validation.conditions.forEach((c) => {
      if (c.condition.displayName === 'rangeValidator') {
        if (!c.condition(question.answer, question.componentProps?.min, question?.componentProps?.max)) {
          newIsValid = false;
          newErrorMessages.push(c.message);
        }
      } else if (c.condition.displayName === 'lengthValidator') {
        if (!c.condition(question.answer, question.componentProps?.length)) {
          newIsValid = false;
          newErrorMessages.push(c.message);
        }
      } else if (!c.condition(question.answer)) {
        newIsValid = false;
        newErrorMessages.push(c.message);
      }
    });
  }
  question.isValid = newIsValid;
  question.errorMessages = newErrorMessages;
};

export const validateBlock = (questions) => {
  if (!questions || !Array.isArray(questions) || questions.length === 0) {
    return [];
  }
  questions.map(q => validateQuestion(q));
  return questions;
};

export const isRequired = (question) => {
  if (!question.validation?.conditions) {
    return false;
  }
  return question.validation.conditions.some(c => typeof c.condition.displayName === 'string' && c.condition.displayName === 'requiredValidator');
};

export const setValidators = (required, conditions, requiredErrorMessageId) => {
  if (required !== false && requiredErrorMessageId) {
    conditions.push({ condition: requiredValidator, message: requiredErrorMessageId });
  }

  return { conditions };
};

export const isEmptyObject = (obj) => {
  if (!obj) {
    return true;
  }
  let isEmpty = true;
  Object.values(obj).forEach((val) => {
    if (val !== undefined) {
      if (typeof val === 'object') {
        const isObjEmpty = isEmptyObject(val);
        if (!isObjEmpty) {
          isEmpty = false;
        }
      } else {
        isEmpty = false;
      }
    }
  });
  return isEmpty;
};

export const isQuestionValid = (question, bAnswers, qAnswers, allowBlankBlock) => {
  if (!showQuestion(question, bAnswers, qAnswers)) {
    return true;
  }

  if (allowBlankBlock) {
    if (!isRequired(question)) {
      return !question.answer || question.isValid;
    }
  }

  return question.isValid;
};

export const isBlockFullyValid = (subBlocksArr, questionsArr, bAnswers, qAnswers, allowBlankBlock) => {
  if (subBlocksArr?.some(b => b.isValid === false)) {
    return false;
  }

  if (questionsArr?.some(q => isQuestionValid(q, bAnswers, qAnswers, allowBlankBlock) === false)) {
    return false;
  }

  const allQuestionsUndefined = questionsArr?.every(q => isQuestionValid(q, bAnswers, qAnswers, allowBlankBlock) === undefined);
  const allSubBlocksUndefined = subBlocksArr?.every(b => b.isValid === undefined);

  if (allQuestionsUndefined || (subBlocksArr !== null && allSubBlocksUndefined)) {
    return undefined;
  }

  return true;
};
